import InvitationAcceptSuccessStep from './InvitationAcceptSuccessStep';

export default InvitationAcceptSuccessStep;
